import {
  FETCH_SPORT_VARIANT,
  FETCH_SPORT_VARIANT_SUCCESS,
  FETCH_SPORT_VARIANT_ERROR
} from '../actions/types'

const initialState = {
  data: [],
  loading: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_SPORT_VARIANT:
      return { ...state, loading: true }
    case FETCH_SPORT_VARIANT_SUCCESS:
      let response = action.payload.data
      return { ...state, data: response, loading: false, success: true }
    case FETCH_SPORT_VARIANT_ERROR:
      response = action.payload.data
      return { ...state, loading: false, error: true }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_variants.js